import React, { Component } from "react";
import { connect } from "react-redux";
import ReportGeneralTable from "./ReportGeneralTable";
import ReportStore from "../../stores/ReportStore";
import FontAwesome from "react-fontawesome";
import { Checkbox } from "react-icheck";
import {
  Popover,
  OverlayTrigger,
  Tabs,
  Tab,
  Breadcrumb,
} from "react-bootstrap";
import { momentHelper } from "./helpers";
import ConfirmPopup from "../../component/element/ConfirmPopup";
import IframeModal from "../../component/element/IframeModal";
// import TaxInvoiceDoc from '../doc/TaxInvoiceDoc'
import TaxinvoiceModal from "../doc/TaxinvoiceModal";
import ReceiptVoucherDoc from "../doc/ReceiptVoucherDoc";
import CreditNoteDoc from "../doc/CreditNoteDoc";

const cHeaderTitles = [
  { title: "วันที่ออก", width: "100px", keyField: "doc_date" },
  { title: "ใบกำกับภาษี", width: "120px", keyField: "bill_no" },
  { title: "ใบงานเลขที่", width: "220px", keyField: "work_no" },
  { title: "ทะเบียนรถ", width: "150px", keyField: "car_registration_no" },
  { title: "ยี่ห้อ", width: "150px", keyField: "brand" },
  { title: "รุ่น", width: "150px", keyField: "model" },
  { title: "กม.", width: "80px", keyField: "mileage" },
  { title: "ชื่อลูกค้า", width: "200px", keyField: "customer_name" },
  { title: "มูลค่า", width: "100px", keyField: "amount_before_vat" },
  { title: "ภาษี", width: "100px", keyField: "vat" },
  { title: "รวมทั้งสิ้น", width: "100px", keyField: "amount" },
  { title: "วันรับเงิน", width: "100px", keyField: "payment_date" },
  { title: "สถานะ", width: "100px", keyField: "work_status" },
];
const cHeaderExcelTitles = [
  { title: "วันที่ออก", width: "100px" },
  { title: "ใบกำกับภาษี", width: "120px" },
  { title: "ชื่อ-บริษัท", width: "200px" },
  { title: "มูลค่า(บาท)", width: "100px" },
  { title: "ภาษีมูลค่าเพิ่ม 7%", width: "100px" },
  { title: "รวมมูลค่า(บาท)", width: "100px" },
];

// const cHeaderTitlesCompany = [
//   {title:'วันที่ออก',width:'100px'},
//   {title:'ออกโดย',width:'100px'},
//   {title:'ใบกำกับภาษี',width:'120px'},
//   {title:'ใบงานเลขที่',width:'220px'},
//   {title:'ทะเบียนรถ',width:'150px'},
//   {title:'ยี่ห้อ',width:'150px'},
//   {title:'รุ่น',width:'150px'},
//   {title:'กม.',width:'80px'},
//   {title:'ชื่อลูกค้า',width:'200px'},
//   {title:'มูลค่า(บาท)',width:'100px'},
//   {title:'วันรับเงิน',width:'100px'},
// ]

const cHeaderTitlesAll = [
  { title: "", width: "50px", checkAll: true, keyField: "check" },
  { title: "วันที่ออก", width: "100px", keyField: "doc_date" },
  { title: "ใบกำกับภาษี", width: "120px", keyField: "bill_no" },
  { title: "ใบงานเลขที่", width: "220px", keyField: "work_no" },
  { title: "ทะเบียนรถ", width: "150px", keyField: "car_registration_no" },
  { title: "ยี่ห้อ", width: "150px", keyField: "brand" },
  { title: "รุ่น", width: "150px", keyField: "model" },
  { title: "กม.", width: "80px", keyField: "mileage" },
  { title: "ชื่อลูกค้า", width: "200px", keyField: "customer_name" },
  { title: "มูลค่า", width: "100px", keyField: "amount_before_vat" },
  { title: "ภาษี", width: "100px", keyField: "vat" },
  { title: "รวมทั้งสิ้น", width: "100px", keyField: "amount" },
  { title: "วันรับเงิน", width: "100px", keyField: "payment_date" },
  { title: "สถานะ", width: "100px", keyField: "work_status" },
  { title: "หมายเหตุ", width: "100px", keyField: "remark" },
];
// const cHeaderTitlesAllCompany = [
//   {title:'',width:'50px',checkAll:true},
//   {title:'วันที่ออก',width:'100px'},
//   {title:'ออกโดย',width:'100px'},
//   {title:'ใบกำกับภาษี',width:'120px'},
//   {title:'ใบงานเลขที่',width:'220px'},
//   {title:'ทะเบียนรถ',width:'150px'},
//   {title:'ยี่ห้อ',width:'150px'},
//   {title:'รุ่น',width:'150px'},
//   {title:'กม.',width:'80px'},
//   {title:'ชื่อลูกค้า',width:'200px'},
//   {title:'มูลค่า(บาท)',width:'100px'},
//   {title:'วันรับเงิน',width:'100px'},
// ]
const viewModeList = ["all", "unpaid", "paid", "cancel"];
class ReportTaxinvoicePage extends Component {
  constructor(...args) {
    super(...args);
    const month = momentHelper.getMonth();
    const year = momentHelper.getYear();
    // const day = momentHelper.getDay()
    const searchBy = "invoice_no";
    const query = "";
    this.state = {
      doc_type: "credit",
      taxinvoice_no: "",
      bill_no: "",
      doc_title: "ใบลดหนี้",
      showTable: true,
      showGenDoc: false,
      doc_no: "",
      data: [],
      companylist: [],
      activeKey: 1,
      month: month,
      year: year,
      day: "00",
      searchBy: searchBy,
      query: query,
      activePage: 0,
      itemPerPage: 13,
      check: [],
      headerTitles: cHeaderTitlesAll,
      // headerTitlesAll:cHeaderTitlesAll,
      isCheckAll: false,
      showSelectMenu: false,
      showRV: false,
      showClose: false,
      loadClose: false,
      isDocClose: false,
      excel_type: "all",
      pdf_template: {
        PrintTaxInvoiceCoverNote: "PrintKKCTaxInvoiceCoverNote",
        PrintTaxInvoiceCoverNoteInsurer: "PrintKKCTaxInvoiceCoverNoteInsurer",
      },
    };
    this.loadedData = false;
    this.refTable = [null, null, null, null];
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  onRowSelect(item) {
    this.setState({ showTable: false });

    if (this.props.onDocShow !== undefined) this.props.onDocShow(item.doc_no);
  }

  // onDocNew(){
  //   this.setState({showTable:false})
  //   let that = this
  //   this.refs.soDoc.loadNewDoc(function(item){
  //     if(that.props.onDocShow!==undefined){
  //       that.props.onDocShow(item.sale_order_no)
  //     }
  //   })
  // }

  onGenDocClose() {
    // let {_that} = this.state
    // this.setState({showGenDoc:false,showTable:true,doc_no:'',showRV:false})
    // if (_that!==undefined) {
    //   setTimeout(()=>{
    //     _that.refreshTable()
    //   },100)
    // }
    this.setState({ isDocClose: true }, () => {
      this.showTable();
    });
  }

  // showTable(){
  //   // this.setState({showTable:true})
  //   this.refs.tiTable.refreshTable()
  //   if(this.props.onTableShow!==undefined){
  //     this.props.onTableShow()
  //   }
  // }

  showTable() {
    this.setState({
      showGenDoc: false,
      showTable: true,
      doc_no: "",
      showRV: false,
      showClose: true,
      loadClose: true,
    });
    if (this.props.onTableShow !== undefined) {
      this.props.onTableShow();
    }
  }

  loadDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    let { activeKey } = this.state;
    ReportStore.loadTaxinvoiceListRange(
      viewModeList[activeKey - 1],
      start,
      end,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      (result) => {
        this.processData(result);
        callback(result);
      }
    );
  }

  loadData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    let { activeKey } = this.state;

    ReportStore.loadTaxinvoiceList(
      viewModeList[activeKey - 1],
      year,
      month,
      day,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      (result) => {
        this.processData(result);
        callback(result);
      }
    );

    // if (activeKey===1 ) {
    //   this.loadedData = true
    //   ReportStore.loadTaxinvoiceList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     result.data = result.data.map((item,index)=>{
    //       item = Object.assign({check:false},item)
    //       return item
    //     })
    //     if (result.companylist.length>1) {
    //       headerTitlesAll = cHeaderTitlesAllCompany
    //     }
    //     this.setState({data:result.data,companylist:result.companylist,headerTitlesAll:headerTitlesAll,isCheckAll:false,check:new Array(result.data.length).fill(false)})
    //     callback(result)
    //   })
    // } else if (activeKey===2 ) {
    //   ReportStore.loadUnpaidList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }

    //     this.setState({data:result.data,companylist:result.companylist,headerTitles:headerTitles,isCheckAll:false})
    //     callback(result)
    //   })
    // } else if (activeKey===3) {
    //   ReportStore.loadPaidList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     this.setState({data:result.data,isCheckAll:false})
    //     callback(result)
    //   })
    // } else if (activeKey===4) {
    //   ReportStore.loadCancelList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     this.setState({data:result.data,isCheckAll:false})
    //     callback(result)
    //   })
    // }
  }

  processData(result) {
    let { headerTitles, activeKey, pdf_template } = this.state;
    if (activeKey === 1) {
      headerTitles = cHeaderTitlesAll;
      result.data = result.data.map((item, index) => {
        item = Object.assign({ check: false }, item);
        return item;
      });
      // if (check.length===0)
      //   this.setState({check:new Array(result.data.length).fill(false)})
      // else
      //   this.setState({check:check})
      this.setState({
        isCheckAll: false,
        showSelectMenu: false,
        check: new Array(result.data.length).fill(false),
      });
    } else {
      headerTitles = cHeaderTitles;
    }
    pdf_template = Object.assign(pdf_template, result.pdf_template);
    this.setState({
      pdf_template: pdf_template,
      companylist: result.companylist,
      headerTitles: headerTitles,
      data: result.data,
    });
  }

  // renderStatus(status,row){
  //   status = status*1
  //   let result  = (<span></span>)
  //   if(status===1){
  //     result =  (<span className='label label-success'>ชำระเงินแล้ว</span>)
  //   }else    if(status===2){
  //     result =  (<span className='label label-primary'>ขายเครดิต</span>)
  //   }else{
  //     result = (<span></span>)
  //   }
  //   if(row.recordid!==undefined && row.recordid*1>0){
  //     result = (<div>{result} {this.renderStockStatus(row.recordid)}</div>)
  //   }
  //   return result
  // }

  renderStatus(status, row) {
    let result = <span></span>;

    if (row.work_status === "0") {
      result = (
        <span className="label label-default" data-value="0">
          <FontAwesome name="clock-o" /> เริ่มต้น
        </span>
      );
    } else if (row.work_status === "1") {
      result = (
        <span className="label label-warning" data-value="1">
          <FontAwesome name="wrench" /> อยู่ระหว่างซ่อม
        </span>
      );
    } else if (row.work_status === "2") {
      result = (
        <span className="label label-primary" data-value="2">
          <FontAwesome name="hourglass-start" /> รอส่งมอบรถ
        </span>
      );
    } else if (row.work_status === "3") {
      result = (
        <span className="label label-success" data-value="3">
          <FontAwesome name="thumbs-o-up" /> ปิดจบงาน
        </span>
      );
    } else if (row.work_status === "5") {
      result = (
        <span className="label label-purple" data-value="5">
          <FontAwesome name="bitcoin" /> ตั้งเบิก
        </span>
      );
    } else {
      result = <span></span>;
    }

    if (row.doc_status !== undefined && row.doc_status * 1 === 2) {
      result = (
        <div>
          {result}
          <span className="label label-success">
            <FontAwesome name="money" /> ชำระเงินแล้ว
          </span>
        </div>
      );
    }
    if (row.doc_cancel !== undefined && row.doc_cancel * 1 === 1) {
      result = (
        <div>
          {result}
          <span className="label label-danger">
            <FontAwesome name="trash" /> ยกเลิก
          </span>
        </div>
      );
    }

    if (row.doc_cancel_remark !== undefined && row.doc_cancel_remark !== "") {
      result = (
        <div>
          {result}
          <span className="label label-danger">
            <FontAwesome name="trash" /> {row.doc_cancel_remark}
          </span>
        </div>
      );
    }

    return result;
  }

  renderWorkNo(data, row) {
    if (data !== "" && data !== null) {
      let title = "ใบงานซ่อม " + data;
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
        </Popover>
      );

      return (
        <span>
          {data}{" "}
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="right"
            overlay={popoverHoverFocus}
          >
            <FontAwesome
              onClick={this.onIconClick.bind(this, data)}
              className="text-blue"
              name="file-text-o"
            />
          </OverlayTrigger>
        </span>
      );
    } else {
      return <span>{data}</span>;
    }
  }

  // renderStockStatus(status){
  //   status = status*1
  //   if(status>0){
  //     return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
  //   }else{
  //     return (<span></span>)
  //   }
  // }

  onIconClick(workNo, e) {
    if (process.env.NODE_ENV === "development") {
      alert("show_work_doc:" + workNo);
    } else {
      window.show_work_doc(workNo);
    }
  }

  // onCheckChange(rowIndex){
  //   let {showSelectMenu,data,check,isCheckAll} = this.state

  //   let ind=0;
  //   let checkItems = data.reduce((rresult,item)=>{
  //     if(check[ind]){
  //       rresult.push(item)
  //     }
  //     ind++;
  //     return rresult
  //   },[])

  //   if(!check[rowIndex] && !this.validateSameCustomer(data[rowIndex],checkItems)){
  //     this.setState({showSelectEror:true})
  //     return
  //   }
  //   check[rowIndex] = !check[rowIndex]

  //   showSelectMenu = false
  //   check.map((item,index)=>{
  //     if(item){
  //       showSelectMenu = true
  //     }
  //     return item
  //   })

  //   isCheckAll = this.checkAll(check)
  //   this.setState({check:check,showSelectMenu:showSelectMenu,isCheckAll:isCheckAll})
  // }

  onCheckChange(rowIndex) {
    let { showSelectMenu, check, isCheckAll } = this.state;

    // let ind=0;
    // let checkItems = data.reduce((rresult,item)=>{
    //   if(check[ind]){
    //     rresult.push(item)
    //   }
    //   ind++;
    //   return rresult
    // },[])

    // if(!check[rowIndex] && !this.validateSameCustomer(data[rowIndex],checkItems)){
    //   this.setState({showSelectEror:true})
    //   return
    // }
    check[rowIndex] = !check[rowIndex];

    showSelectMenu = false;
    // check.map((item,index)=>{
    //   if(item){
    //     showSelectMenu = true
    //   }
    //   return item
    // })
    let key = check.findIndex((x) => x !== false);
    if (key !== -1) showSelectMenu = true;

    isCheckAll = this.checkAll(check);
    this.setState({
      check: check,
      showSelectMenu: showSelectMenu,
      isCheckAll: isCheckAll,
    });
  }

  // checkAll(check) {
  //   let isCheckAll = true
  //   check.forEach((item,index)=>{
  //     if (!item)
  //       isCheckAll = false
  //   })
  //   return isCheckAll
  // }

  checkAll(check) {
    let { data } = this.state;
    let isCheckAll = true;
    check.forEach((item, index) => {
      if (!item && data[index].work_status !== "3") isCheckAll = false;
    });
    return isCheckAll;
  }

  validateSameCustomer(newItem, checkItems) {
    let valid = true;
    checkItems.map((item, index) => {
      if (item.customer_name !== newItem.customer_name) {
        valid = false;
      }
      return item;
    });

    return valid;
  }

  // renderRowData(){ //data
  //   //let renderColumn = (this.props.onRenderColumn!==undefined)?this.props.onRenderColumn:this.onRenderColumn.bind(this)
  //   let {data,check,activeKey,companylist,headerTitles} = this.state
  //   let firstRowAt = -1;
  //   data = data.map((newRow, rid) => {
  //     //let newRow = JSON.parse(JSON.stringify(row))

  //     if(rid>0 && data[rid-1].doc_no===data[rid].doc_no){
  //       if(firstRowAt<0)
  //         firstRowAt = rid-1
  //       data[firstRowAt]['rowSpan'] = data[firstRowAt]['rowSpan']+1
  //       data[rid]['rowSpan'] = 0
  //     }else{
  //       firstRowAt = -1
  //       newRow['rowSpan'] = 1
  //     }
  //     return newRow
  //   })

  //   if(data.length===0){
  //     return (<tr><td colSpan={headerTitles.length}>ไม่พบข้อมูล</td></tr>)
  //   } else {
  //     return data.map((item,index)=>(
  //       (
  //         <tr key={index}>
  //           {this.state.activeKey==1 ? (<td className='text-center'><Checkbox onChange={this.onCheckChange.bind(this,index)} checked={check[index]} checkboxClass="icheckbox_square-blue" increaseArea="20%" label="" /></td>) : ('') }
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan}  onClick={this.onRowSelect.bind(this,item)}>{item.doc_date}</td>):('')}
  //           {companylist.length>1?(<td onClick={this.onRowSelect.bind(this,item)}>{item.issued_doc_by}</td>):('')}
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan}  onClick={this.onRowSelect.bind(this,item)}>{item.bill_no}</td>):('')}
  //           <td>{this.renderWorkNo(item.work_no,item)}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.car_registration_no}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.brand}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.model}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.mileage}</td>
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan}  onClick={this.onRowSelect.bind(this,item)}>{item.customer_name}</td>):('')}
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan} className='text-right'  onClick={this.onRowSelect.bind(this,item)}>{item.amount}</td>):('')}
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.payment_date}</td>

  //         </tr>
  //       )
  //     ))
  //   }
  // }

  validBeforePrint(_data) {
    let customer_name = [];
    _data.forEach((item, index) => {
      if (item) {
        if (customer_name.indexOf(item.customer_name) === -1)
          customer_name.push(item.customer_name);
      }
    });

    return customer_name.length > 1 ? false : true;
  }

  onTypePrintSelect(number) {
    if (number === 2) {
      this.onPrintClick(number);
    } else {
      let { check } = this.state;
      let isValideCustomer = this.validBeforePrint(check);
      if (isValideCustomer) {
        this.onPrintClick(number);
      } else {
        this.setState({ showSelectEror: true });
      }
    }
  }

  onCreditNotePrintSelect(number) {
    let { check, data } = this.state;
    let select = check.indexOf(true);
    if (number === 2) {
      if (select !== -1) {
        let ivlist = [];
        check.forEach((item, index) => {
          if (item === true) ivlist.push(data[index].doc_no);
        });
        let doc_nos = ivlist.join();
        this.setState(
          {
            showClose: false,
            loadClose: false,
            showRV: true,
            showTable: false,
            doc_title: "ใบสำคัญรับ",
          },
          () => {
            this.refs.rvDoc
              .getWrappedInstance()
              .loadInvoiceListStatusNewDoc(doc_nos);
          }
        );
      }
    } else {
      let count_true = 0;
      check.forEach((item, index) => {
        if (item === true) count_true++;
      });
      if (count_true > 1) {
        this.setState({ showSelect1Eror: true });
        return false;
      }
      if (number === 0) {
        this.setState({ doc_title: "ใบลดหนี้", doc_type: "credit" });
      } else if (number === 1) {
        this.setState({ doc_title: "ใบเพิ่มหนี้", doc_type: "debit" });
      }
      let select = check.indexOf(true);
      if (select !== -1)
        this.setState({
          showTaxList: true,
          taxinvoice_no: data[select].doc_no,
          bill_no: data[select].bill_no,
        });
    }
    this.setState({ isDocClose: false });
  }

  onTaxinvoiceSelect(datas) {
    let { taxinvoice_no, bill_no } = this.state;
    if (datas.itemlist.length > 0) {
      this.setState({ showTable: false, showTaxList: false, showGenDoc: true });
      this.refs.cnDoc
        .getWrappedInstance()
        .setDataFromTaxinvoice(datas, taxinvoice_no, bill_no);
    }
  }

  onPrintClick(number) {
    let { check, data, pdf_template } = this.state;
    // let _item = {}
    let doc_nos = [];

    data.forEach(function (item, index) {
      if (check[index]) {
        // _item = item
        doc_nos.push(item.doc_no);
      }
    });

    let doc_no = doc_nos.join();
    let file =
      number === 0
        ? pdf_template.PrintTaxInvoiceCoverNote
        : number === 1
        ? pdf_template.PrintTaxInvoiceCoverNoteInsurer
        : "PrintShippingLabel&idlist=" + doc_no + "&doc=taxinvoice";
    let url = "";
    if (process.env.NODE_ENV === "development") {
      if (number === 2) url = "./?startPage=" + file;
      else url = "./?startPage=" + file + "&tivlist=" + doc_no;
    } else {
      if (number === 2) url = "./pdf/v2/?startPage=" + file;
      else url = "./pdf/v2/?startPage=" + file + "&tivlist=" + doc_no;
    }
    this.refs.iframe.loadUrl(url);
  }

  onRenderColumn(data, col, row, rowIndex) {
    let { check, activeKey } = this.state;
    if (col === 0 && activeKey === 1) {
      return (
        <Checkbox
          onChange={this.onCheckChange.bind(this, rowIndex)}
          checked={check[rowIndex] !== false ? true : false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status === "3" ? true : false}
        />
      );
    } else if (
      (col === 3 && activeKey === 1) ||
      (col === 2 && activeKey !== 1)
    ) {
      return this.renderWorkNo(data, row);
    } else if (
      (col === 17 && activeKey === 1) ||
      (col === 16 && activeKey > 1)
    ) {
      return this.renderStatus(data, row);
    } else if (col === 9 && activeKey === 1) {
      return this.getNumberFormat(row.amount_before_vat);
    } else if (col === 10 && activeKey === 1) {
      return (
        <span className="pull-right">{this.getNumberFormat(row.vat)}</span>
      );
    } else if (col === 11 && activeKey === 1) {
      return this.getNumberFormat(row.amount);
    } else if (col === 16 && activeKey === 1) {
      return row.payment_date;
    } else {
      return <span>{data}</span>;
    }
  }

  onRenderKeyColumn(data, key, row, rowIndex) {
    let { check, activeKey } = this.state;
    if (key === "check") {
      return (
        <Checkbox
          onChange={this.onCheckChange.bind(this, rowIndex)}
          checked={check[rowIndex] !== false ? true : false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status === "3" ? true : false}
        />
      );
    } else if (key === "work_no") {
      return this.renderWorkNo(data, row);
    } else if (key === "work_status") {
      return this.renderStatus(data, row);
    } else {
      return <span>{data}</span>;
    }
  }

  onRenderExcelColumn(data, col, row, rowIndex) {
    return <span>{data}</span>;
  }

  onTypeExcelSelect(type, completeFunc) {
    this.setState({ excel_type: type }, () => {
      if (completeFunc !== undefined) completeFunc();
    });
  }

  renderCustomExcelFooter(data) {
    let { excel_type } = this.state;
    let amount_before_vat = 0;
    let vat = 0;
    let amount = 0;
    data.forEach((item, index) => {
      amount_before_vat +=
        item.amount_before_vat === "" ||
        item.amount_before_vat === null ||
        item.amount_before_vat === undefined ||
        isNaN(item.amount_before_vat)
          ? 0
          : item.amount_before_vat * 1;
      vat +=
        item.vat === "" ||
        item.vat === null ||
        item.vat === undefined ||
        isNaN(item.vat)
          ? 0
          : item.vat * 1;
      amount +=
        item.amount === "" ||
        item.amount === null ||
        item.amount === undefined ||
        isNaN(item.amount)
          ? 0
          : item.amount * 1;
    });
    return (
      <tfoot>
        {excel_type === "taxinvoice" ? (
          <tr>
            <th colSpan={3}></th>
            <th className="text-right">
              {this.getNumberFormat(amount_before_vat)}
            </th>
            <th className="text-right">{this.getNumberFormat(vat)}</th>
            <th className="text-right">{this.getNumberFormat(amount)}</th>
          </tr>
        ) : (
          <tr>
            <th colSpan={9}></th>
            <th className="text-right">
              {this.getNumberFormat(amount_before_vat)}
            </th>
            <th className="text-right">{this.getNumberFormat(vat)}</th>
            <th className="text-right">{this.getNumberFormat(amount)}</th>
            <th colSpan={2}></th>
          </tr>
        )}
      </tfoot>
    );
  }

  onTabsSelect(e) {
    let { headerTitles } = this.state;
    if (e === 1) {
      headerTitles = cHeaderTitlesAll;
    }
    this.setState({ activeKey: e, headerTitles: headerTitles }, () => {
      this.refTable[e - 1].refreshTable();
    });
    // let {year,month,day,searchBy,query,activePage,itemPerPage,headerTitles} = this.state
    // if (e===1) {
    //   ReportStore.loadTaxinvoiceList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     this.setState({data:result.data,activeKey:e,isCheckAll:false})
    //   })
    // } else if (e===2) {
    //   ReportStore.loadUnpaidList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
    //     this.setState({data:result.data,activeKey:e,headerTitles:headerTitles,isCheckAll:false})
    //   })
    // } else if (e===3) {

    //   ReportStore.loadPaidList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
    //     this.setState({data:result.data,activeKey:e,headerTitles:headerTitles,isCheckAll:false})
    //   })
    // } else if (e===4) {
    //   ReportStore.loadCancelList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
    //     this.setState({data:result.data,activeKey:e,headerTitles:headerTitles,isCheckAll:false})
    //   })
    // }
  }

  // onCheckAll() {
  //   let {data,isCheckAll,check} = this.state
  //   if (data.length==0)
  //     return false

  //   if (!isCheckAll) {
  //     let isValideCustomer = data.find((item,index)=>{
  //       return this.validateSameCustomer(item,data)==true
  //     })

  //     if (!isValideCustomer) {
  //       this.setState({showSelectEror:true})
  //     } else {
  //       let newCheck = check.map((item,index)=>{
  //         if (data[index].work_status=='3')
  //           item = true // false
  //         else
  //           item = true

  //         return item
  //       })

  //       if (newCheck.indexOf(true)==-1)
  //         this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
  //       else
  //         this.setState({isCheckAll:true,check:newCheck,showSelectMenu:true})
  //     }
  //   } else {
  //     let newCheck = check.map((item,index)=>{
  //       item = false
  //       return item
  //     })
  //     this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
  //   }
  // }

  onCheckAll() {
    let { data, isCheckAll, check } = this.state;
    if (data.length === 0) return false;

    if (!isCheckAll) {
      let newCheck = check.map((item, index) => {
        if (data[index].work_status === "3") return false;
        else return true; // data[index]
      });

      this.setState({
        isCheckAll: true,
        check: newCheck,
        showSelectMenu: true,
      });
    } else {
      let newCheck = check.map((item, index) => {
        item = false;
        return item;
      });
      this.setState({
        isCheckAll: false,
        check: newCheck,
        showSelectMenu: false,
      });
    }
  }

  onRenderCheckAll(key, index) {
    return (
      <th
        key={key + "-" + index}
        className={"text-center"}
        style={{ width: "50px", maxWidth: "50px" }}
      >
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        ></Checkbox>
      </th>
    );
  }

  render() {
    let {
      isDocClose,
      showTable,
      showGenDoc,
      activeKey,
      showSelectEror,
      showSelect1Eror,
      showSelectMenu,
      headerTitles,
      doc_type,
      showRV,
    } = this.state;
    const searchOptions = [
      {
        label: "เลขที่ใบกำกับภาษี",
        value: "bill_no",
      },
      {
        label: "ใบงานเลขที่",
        value: "work_no",
      },
      {
        label: "ทะเบียนรถ",
        value: "car_registration_no",
      },
      {
        label: "ลูกค้า/เจ้าของรถ",
        value: "customer_name",
      },
      {
        label: "บริษัทประกัน",
        value: "insurance_name",
      },
    ];

    // let title = (<div><FontAwesome name='files-o' /> ทั้งหมด</div>)
    // let title2 = (<div><FontAwesome name='money' /> รอเก็บเงิน</div>)
    // let title3 = (<div><FontAwesome name='thumbs-o-up' /> ได้รับเงินเรียบร้อย</div>)
    // let title4 = (<div><FontAwesome name='trash' /> ยกเลิก</div>)

    const tabsList = [
      {
        key: "all",
        title: (
          <div>
            <FontAwesome name="files-o" /> ทั้งหมด
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "unpaid",
        title: (
          <div>
            <FontAwesome name="money" /> รอเก็บเงิน
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "paid",
        title: (
          <div>
            <FontAwesome name="thumbs-o-up" /> ได้รับเงินเรียบร้อย
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "cancel",
        title: (
          <div>
            <FontAwesome name="trash" /> ยกเลิก
          </div>
        ),
        loadOnShow: true,
      },
    ];

    let keyFieldList = headerTitles.reduce((result, item, index) => {
      if (item.keyField) {
        result.push(item.keyField);
      }
      return result;
    }, []);

    return (
      <div>
        <div>
          <Tabs
            style={{ display: showTable ? "block" : "none" }}
            activeKey={activeKey}
            id="tabs-report-tax-invoice-page"
            onSelect={this.onTabsSelect.bind(this)}
          >
            {tabsList.map((item, index) => (
              <Tab key={index} eventKey={index + 1} title={item.title}>
                <div style={{ display: showTable ? "block" : "none" }}>
                  <ReportGeneralTable
                    ref="tiTable"
                    onRef={(ref) => {
                      this.refTable[index] = ref;
                    }}
                    title="ใบเสร็จรับเงิน/ใบกำกับภาษี"
                    newTitle="เพิ่มรายการ"
                    showNewButton={false}
                    showPrintButton={true}
                    showSelectMenu={showSelectMenu && activeKey === 1}
                    // show={activeKey===index+1}
                    // loadFirst={activeKey===index+1}
                    // loadOnShow={item.loadOnShow}
                    headerTitles={headerTitles}
                    headerExcelTitles={cHeaderExcelTitles}
                    excludeColumn={[
                      "status_html",
                      "doc_no",
                      "doc_status",
                      "issued_doc_by",
                      "doc_cancel",
                      "doc_cancel_remark",
                    ]}
                    excludeClickColumn={["work_no", "bill_no"]}
                    bodyColumn={keyFieldList}
                    searchOptions={searchOptions}
                    searchBy={"bill_no"}
                    loadData={this.loadData.bind(this)}
                    loadDataRange={this.loadDataRange.bind(this)}
                    onRenderCheckAll={this.onRenderCheckAll.bind(
                      this,
                      item.key,
                      index
                    )}
                    onRenderColumn={this.onRenderKeyColumn.bind(this)}
                    onRenderExcelColumn={this.onRenderExcelColumn.bind(this)}
                    onRowSelect={this.onRowSelect.bind(this)}
                    onPrintClick={this.onPrintClick.bind(this)}
                    onTypePrintSelect={this.onTypePrintSelect.bind(this)}
                    onCreditNotePrintSelect={this.onCreditNotePrintSelect.bind(
                      this
                    )}
                    printTitle={"พิมพ์เอกสาร"}
                    selectMenuTitle={"สร้างใบปะหน้า"}
                    btnTitlePrint={"พิมพ์ตาราง"}
                    docType={"taxinvoice"}
                    viewMode={viewModeList[activeKey - 1]}
                    minWidth={1300}
                    isMobile={this.props.isMobile}
                    mobileFieldMap={{
                      title: "customer_name",
                      amount: "amount",
                      sub_title: "bill_no",
                      date: "doc_date",
                      status: "work_status",
                      sub_status: "",
                    }}
                    renderWorkStatus={this.renderStatus.bind(this)}
                    show={
                      isDocClose
                        ? activeKey === index + 1
                          ? this.state.showClose
                          : false
                        : this.state.showClose
                    }
                    loadOnShow={
                      isDocClose
                        ? activeKey === index + 1
                          ? this.state.loadClose
                          : false
                        : this.state.loadClose
                    }
                    callOut={activeKey === index + 1 ? false : true}
                    customExcelFooter={true}
                    renderCustomExcelFooter={this.renderCustomExcelFooter.bind(
                      this
                    )}
                    onTypeExcelSelect={this.onTypeExcelSelect.bind(this)}
                    excelType={this.state.excel_type}
                  />
                </div>
              </Tab>
            ))}
          </Tabs>
        </div>
        {/* <div style={{display:(!showTable?'':'none')}}>              
              <TaxInvoiceDoc                 
                ref='tivDoc' 
                title={'ใบกำกับภาษี'}
                docType={'taxinvoice'}
                docSName={'tiv'}
                docName={'taxinvoice_doc'}
                onClose={this.onDocClose.bind(this)}
              />              
        </div> */}
        <div style={{ display: showGenDoc || showRV ? "" : "none" }}>
          <Breadcrumb>
            <Breadcrumb.Item
              href="#"
              active={false}
              onClick={this.onGenDocClose.bind(this)}
            >
              <FontAwesome name="table" /> ตารางใบเสร็จรับเงิน/ใบกำกับภาษี
            </Breadcrumb.Item>
            <Breadcrumb.Item href="#" active={true}>
              {doc_type === "credit" ? "ใบลดหนี้" : "ใบเพิ่มหนี้"}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div style={{ display: showGenDoc && !showRV ? "" : "none" }}>
          <CreditNoteDoc
            ref="cnDoc"
            title={this.state.doc_title}
            docType={doc_type === "credit" ? "creditnote" : "debitnote"}
            docSName={doc_type === "credit" ? "cn" : "dn"}
            docName={doc_type === "credit" ? "creditnote_doc" : "debitnote_doc"}
            onClose={this.onGenDocClose.bind(this)}
          />
        </div>
        <div style={{ display: showRV ? "" : "none" }}>
          <ReceiptVoucherDoc
            ref="rvDoc"
            title={"ใบสำคัญรับ"}
            docType={"receiptvoucher"}
            docSName={"rv"}
            docName={"receiptvoucher_doc"}
            invoiceStatusDocType={"taxinvoice"}
            onClose={this.onGenDocClose.bind(this)}
          />
        </div>
        <ConfirmPopup
          show={showSelect1Eror}
          title="เกิดช้อผิดพลาด"
          confirmTitle="ทำการเลือกใหม่"
          cancelTitle="ยกเลิก"
          message="สามารถเลือกได้ 1 รายการเท่านั้น โปรดลองใหม่"
          onConfirm={() => {
            this.setState({ showSelect1Eror: false });
          }}
          onHide={() => {
            this.setState({ showSelect1Eror: false });
          }}
        />
        <ConfirmPopup
          show={showSelectEror}
          title="เกิดช้อผิดพลาด"
          confirmTitle="ทำการเลือกใหม่"
          cancelTitle="ยกเลิก"
          message="กรุณาเลือกชื่อลูกค้าหรือประกันเดียวกัน โปรดลองใหม่"
          onConfirm={() => {
            this.setState({ showSelectEror: false });
          }}
          onHide={() => {
            this.setState({ showSelectEror: false });
          }}
        />
        <IframeModal ref="iframe" title={"พิมพ์เอกสาร"} />
        <TaxinvoiceModal
          show={this.state.showTaxList}
          tivNo={this.state.taxinvoice_no}
          onHide={() => {
            this.setState({ showTaxList: false });
          }}
          onItemsSelect={this.onTaxinvoiceSelect.bind(this)}
        />
      </div>
    );
  }
}

export default ReportTaxinvoicePage = connect(
  (state) => ({ messages: state.message.view.report.ReportTaxinvoicePage }),
  null,
  null,
  { withRef: true }
)(ReportTaxinvoicePage);



// WEBPACK FOOTER //
// ./src/view/report/ReportTaxinvoicePage.js